var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "landing-page" },
    [
      _c(
        "el-row",
        { staticClass: "container" },
        [
          _c("el-col", { staticClass: "header-section", attrs: { span: 24 } }, [
            _c("h1", { staticClass: "main-title" }, [
              _vm._v("Unlock More Sales with UNIFI Property")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "subtitle" }, [
              _vm._v(
                "\n        Are you a real estate agent specializing in off-the-plan properties or new developments?\n        UNIFI Property is the premier platform to showcase your projects and connect with an\n        engaged audience of buyers looking for the latest in new properties.\n        Join us to access a streamlined, data-rich environment designed to empower agents\n        and simplify the buying journey for your clients.\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "content-section" },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticClass: "image-container" }, [
                  _c("img", {
                    staticClass: "feature-image",
                    attrs: {
                      src: require("./../../../assets/agent-section-2-page-background.png"),
                      alt: "UNIFI Property Platform Preview"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "features-column", attrs: { span: 24 } },
                [
                  _c("h2", { staticClass: "features-title" }, [
                    _vm._v("Why Join UNIFI Property?")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "features-list" }, [
                    _c("div", { staticClass: "feature-item" }, [
                      _c("h3", { staticClass: "feature-item-title" }, [
                        _vm._v("Targeted Audience :")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "feature-item-description" }, [
                        _vm._v(
                          "Reach buyers who are specifically interested in off-the-plan and newly constructed properties. Our platform is built for those seeking modern living spaces and investment opportunities, increasing the chances of genuine inquiries and faster sales."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "feature-item" }, [
                      _c("h3", { staticClass: "feature-item-title" }, [
                        _vm._v("Enhanced Listings :")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "feature-item-description" }, [
                        _vm._v(
                          "Showcase your properties with comprehensive listings that include floor plans, development site maps, pricing details, fee breakdowns, and more. Our intuitive layout lets buyers visualize, evaluate, and compare properties effortlessly."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "feature-item" }, [
                      _c("h3", { staticClass: "feature-item-title" }, [
                        _vm._v("Sell Property While You Sleep :")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "feature-item-description" }, [
                        _vm._v(
                          "Help buyers take the next step with our $1,000 online reservation option. This feature allows buyers to secure properties exclusively for seven days, expediting the sales process while fostering client confidence."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "feature-item" }, [
                      _c("h3", { staticClass: "feature-item-title" }, [
                        _vm._v("Professional Support & Tools :")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "feature-item-description" }, [
                        _vm._v(
                          "UNIFI Property provides resources tailored to agent needs, from marketing support to dedicated agent dashboards, making it easier to manage your listings and engage with interested buyers effectively."
                        )
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55d40d9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d40d9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/agentRegistration/agentRegistrationSection2.vue
// module id = null
// module chunks = 